export const customScrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth', // for smooth scrolling
  });
};
